import React from 'react';
import FileTypeIcon from '../icons/FileTypeIcon';
import { X } from 'lucide-react';
import styles from '../layout/MainContent.module.css';

/**
 * Helper function to detect file type from name
 */
function detectTypeFromName(fileName) {
  if (!fileName) return 'unknown';

  // Check for Blender virtual files
  if (fileName.includes('Blender:') || fileName.includes('.blender')) {
    return 'blender';
  }

  // Check for FreeCAD virtual files
  if (fileName.includes('FreeCAD:') || fileName.includes('.freecad')) {
    return 'freecad';
  }

  // Check for JupyterLab virtual files first
  if (fileName.includes('JupyterLab:') || fileName.includes('.jupyterlab')) {
    return 'jupyterlab';
  }

  // Check for KiCad virtual files
  if (fileName.includes('KiCad:') || fileName.includes('.kicad')) {
    return 'kicad';
  }
  
  const parts = fileName.split('.');
  const ext = parts.length > 0 ? parts.pop().toLowerCase() : '';
  if (!ext) return 'unknown';
  
  if (ext === 'pdf') return 'pdf';
  if (ext === 'csv') return 'csv';
  if (ext === 'doc' || ext === 'docx') return 'doc';

  return 'unknown';
}

/**
 * TabBar component for displaying file tabs
 */
export default function TabBar({
  files = [],
  activeFileId,
  onTabSelect,
  onTabClose,
  className,
  primaryMode = false, // Indicates if this tab is the primary one in split view
}) {
  if (files.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.tabsBar} ${className || ''}`}>
      {files.map(file => {
        const isActive = file.id === activeFileId;
        return (
          <div
            key={file.id}
            className={isActive ? `${styles.tabItem} ${styles.active}` : styles.tabItem}
            onClick={() => onTabSelect(file.id)}
          >
            <FileTypeIcon
              type={file.type || detectTypeFromName(file.name)}
              className={styles.fileTypeIcon}
            />
            <span className={styles.tabText}>{file.name}</span>
            <div
              className={styles.tabCloseBtn}
              onClick={(e) => onTabClose(e, file.id)}
              title={primaryMode && isActive ? "Close split view" : "Close tab"}
            >
              <X size={14} />
            </div>
            {/* Tooltip for full filename */}
            <div className={styles.tooltip}>
              {file.name}
            </div>
          </div>
        );
      })}
    </div>
  );
} 